module.exports = __webpack_public_path__ + "img/AQ.efdbbc8d.svg";